(function () {
'use strict';
window.wofpEngine = '2026-11-01bd1';
var root = document.getElementById('wofpb');
if (!root) return;
var bootEl = document.getElementById('wofp-boot');
var boot;
try {
boot = JSON.parse(bootEl.textContent);
} catch (e) {
if (window.console) console.error('wofp: product data block is not valid JSON.', e, bootEl && bootEl.textContent);
return;
}
if (!boot || !boot.variants || !boot.variants.length) {
if (window.console) console.error('wofp: no variants in the data block. This block must sit on a product template.');
return;
}
window.wofpReady = true;
function safely(fn, label) {
try { fn(); } catch (e) { if (window.console) console.error('wofp ' + label, e); }
}
var OZ = 28.349523125;
var P16 = 16 * OZ;
var P64 = 64 * OZ;
var DAY = 86400000;
var STORE = 'wyn_dog';
/* BIRTHDAYS (2026-11-01, Michael's call). A dog with a birthday gets its age
   from the birthday on every page (wynprofile.js), so the Puppy / Adult /
   Senior row is hidden for it and the fold is relabelled, since only the
   activity question is left inside. Everyone else sees the page unchanged. */
var BD_FOLD_LABEL = 'Very active?';
var $ = function (id) { return document.getElementById(id); };
var section = root.closest('.shopify-section') || root.parentElement;
if (section && !(window.CSS && CSS.supports && CSS.supports('selector(:has(*))'))) {
section.style.margin = '0';
section.style.padding = '0';
var cont = section.querySelector('.container');
if (cont) { cont.style.overflow = 'visible'; cont.style.maxWidth = 'none'; cont.style.width = '100%'; cont.style.padding = '0'; }
}
var WSTART = Math.round(parseFloat(boot.wtStart));
if (!(WSTART >= 1 && WSTART <= 250)) WSTART = 40;
/* The shared profile is owned by wynprofile.js. This page has no spay/neuter
   control by design, but it MUST honour an answer given on the calculator
   page, so neuter is read here and never written. */
function readDog() {
var d = { weight_lb: WSTART, age: '1', activity: '1.55', portion: 100, neuter: 'neutered', known: false };

if (window.wynProfile) {
var p = window.wynProfile.get();
if (p.portion > 0 && p.portion <= 100) d.portion = Math.round(p.portion);
if (p.neuter) d.neuter = p.neuter;
if (p.weight_lb > 0) {
d.weight_lb = Math.round(p.weight_lb);
if (p.age) d.age = String(p.age);
if (p.activity) d.activity = String(p.activity);
if (p.updated > 0) d.updated = p.updated;
d.known = true;
}
return d;
}

/* Fallback for a missing asset: exactly the old behaviour, minus neuter,
   which has nowhere to come from without the module. */
try {
var raw = localStorage.getItem(STORE);
if (!raw) return d;
var s = JSON.parse(raw);
if (!s) return d;
if (s.portion > 0 && s.portion <= 100) d.portion = Math.round(s.portion);
if (typeof s.weight_lb === 'number' && s.weight_lb >= 1 && s.weight_lb <= 250) {
d.weight_lb = Math.round(s.weight_lb);
if (s.age) d.age = String(s.age);
if (s.activity) d.activity = String(s.activity);
if (s.updated > 0) d.updated = s.updated;
d.known = true;
}
} catch (e) {}
return d;
}
var dog = readDog();
/* The dog's name is read, never written here: the cart's info collector and the
   account hub own it. Used only to make the page talk about THEIR dog. */
function dogName() {
var n = '';
try {
if (window.wynProfile) n = window.wynProfile.get().name || '';
if (!n) { var x = JSON.parse(localStorage.getItem('wyn_dog_x') || '{}'); n = x && x.name ? x.name : ''; }
} catch (e) { n = ''; }
n = String(n || '').replace(/\s+/g, ' ').trim();
if (n.length > 24) n = '';
return n;
}
function fill(tpl, map) {
var s = String(tpl || '');
for (var k in map) s = s.split('{' + k + '}').join(map[k]);
return s;
}
window.wofpDog = function () { return { weight_lb: dog.weight_lb, age: dog.age, activity: dog.activity, portion: porPct(), known: !!dog.known, name: dogName() }; };
var saveTimer = null;
var stamp = 0;
function saveDog() {
dog.known = true;
stamp = Date.now();
try { document.dispatchEvent(new CustomEvent('wyn:dog', { detail: { weight_lb: dog.weight_lb, age: dog.age, activity: dog.activity, portion: dog.portion }, bubbles: true })); } catch (e2) {}
if (saveTimer) clearTimeout(saveTimer);
saveTimer = setTimeout(function () {
if (window.wynProfile) {
/* MERGE. This page owns weight, age, activity and portion. Anything else
   in the profile, neuter above all, must survive untouched. */
window.wynProfile.set({
weight_lb: dog.weight_lb, age: dog.age, activity: dog.activity,
portion: dog.portion, source: 'product'
}, { silent: true });
return;
}
try { localStorage.setItem(STORE, JSON.stringify({ weight_lb: dog.weight_lb, age: dog.age, activity: dog.activity, portion: dog.portion, updated: Date.now() })); } catch (e) {}
}, 400);
}
var WMIN = parseFloat(boot.wtMin) || 3;
var WMAX = parseFloat(boot.wtMax) || 130;
var WMID = parseFloat(boot.wtMid) || 40;
var WK = Math.log((WMID - WMIN) / (WMAX - WMIN)) / Math.log(0.5);
var WSNAP = parseFloat(boot.wtSnap) || 0;
function wtStep(w) { return (WSNAP > 0 && w >= WSNAP) ? 5 : 1; }
function snapWt(w) {
if (WSNAP > 0 && w >= WSNAP - 2.5) return Math.min(WMAX, Math.round(w / 5) * 5);
return Math.round(w);
}
function posToWt(p) { return snapWt(WMIN + (WMAX - WMIN) * Math.pow(p / 1000, WK)); }
function wtToPos(w) {
var t = (Math.min(WMAX, Math.max(WMIN, w)) - WMIN) / (WMAX - WMIN);
return Math.round(1000 * Math.pow(t, 1 / WK));
}
/* ONE FORMULA. wynfeed.js is the source of truth for maintenance calories,
   including the spay/neuter factor this page has no control for. boot.cm is
   the per-diet multiplier and is applied on top, exactly as wynFeed.plan()
   applies its own diet factor.

   The mirror below runs ONLY if wynfeed.js failed to load. It is written to
   give the SAME answer, neuter included, so a missing asset degrades the
   page rather than silently changing anyone's numbers. If the library's
   formula ever changes, change this with it. */
var NEUTER_F = { neutered: 1, intact: 1.125 };
/* SAME divisor as wynfeed.js CFG.LB_PER_KG, so the mirror is bit-identical
   to the library rather than merely close. */
function rer(lb) { return 70 * Math.pow(lb / 2.2046226218, 0.75); }
function merFull() {
var cm = parseFloat(boot.cm); if (!(cm > 0)) cm = 1;

if (window.wynFeed && window.wynFeed.maintenanceKcal) {
return window.wynFeed.maintenanceKcal({
weight_lb: dog.weight_lb,
ageFactor: parseFloat(dog.age),
activity: parseFloat(dog.activity),
neuter: dog.neuter
}) * cm;
}

var act = parseFloat(dog.activity); if (!(act > 0)) act = 1.55;
var age = parseFloat(dog.age); if (!(age > 0)) age = 1;
var nu = NEUTER_F[dog.neuter]; if (!(nu > 0)) nu = 1;
var fr = parseFloat(boot.fresh); if (!(fr > 0)) fr = 1;
return rer(dog.weight_lb) * act * age * nu * cm * fr;
}
var PORNAME = { 100: 'all their food', 50: 'half their food', 25: 'a topper' };
var PORSUM = { 50: 'half their food', 25: 'as a topper' };
var PORSET = null;
function porPct() {
if (boot.porOn === false) return 100;
var p = parseFloat(dog.portion);
if (!(p > 0 && p <= 100)) return 100;
if (PORSET && !PORSET[p]) return 100;
return p;
}
function mer() { return merFull() * porPct() / 100; }
function packetGrams(v, i) {
if (v && v.w > 0) return v.w;
return i === 0 ? P16 : P64;
}
function packetKcal(g) { return g / 1000 * boot.kcalKg; }
function money(c) { return '$' + (c / 100).toFixed(2); }
function fmtSpan(d) {
if (!(d > 0)) return '';
if (d < 0.25) return 'under \u00BD day';
if (d >= 10) return 'about ' + Math.round(d) + ' days';
var h = Math.round(d * 2) / 2;
var w = Math.floor(h + 0.001);
var num = (h - w >= 0.499) ? (w > 0 ? w + '\u00BD' : '\u00BD') : String(w);
return 'about ' + num + (h <= 1 ? ' day' : ' days');
}
var views = root.querySelectorAll('.wofp-view');
var ixEls = root.querySelectorAll('.wofp-ix i');
var viewBtns = root.querySelectorAll('.wofp-views__b');
var VIEWNAME = { angle: 'Angle', over: 'Top', mural: 'Packet' };
function showView(name) {
var i;
for (i = 0; i < views.length; i++) views[i].classList.toggle('is-on', views[i].getAttribute('data-view') === name);
root.classList.toggle('is-mural', name === 'mural');
for (i = 0; i < ixEls.length; i++) ixEls[i].classList.toggle('is-on', !!views[i] && views[i].classList.contains('is-on'));
var live = $('wofp-view-live');
if (live) live.textContent = (VIEWNAME[name] || name) + ' view';
}
function stepView(d) {
var cur = 0, n = views.length;
for (var i = 0; i < n; i++) if (views[i].classList.contains('is-on')) cur = i;
return views[((cur + d) % n + n) % n].getAttribute('data-view');
}
var bowl = root.querySelector('.wofp-show__bowl');
var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)');
var busy = false;
function slide(x, o, ms) {
if (calm && calm.matches) return;
bowl.style.transition = ms ? 'translate ' + ms + 'ms cubic-bezier(.22,.61,.36,1),opacity ' + ms + 'ms' : 'none';
bowl.style.translate = x + 'px';
bowl.style.opacity = o;
}
function goView(d) {
if (busy) return;
if (!bowl || views.length < 2 || (calm && calm.matches)) { showView(stepView(d)); return; }
busy = true;
slide(d * -76, 0, 110);
setTimeout(function () {
showView(stepView(d));
slide(d * 76, 0, 0);
void bowl.offsetWidth;
slide(0, 1, 230);
setTimeout(function () { busy = false; }, 240);
}, 120);
}
if (bowl && views.length > 1) {
var sx = 0, sy = 0, st = 0, grip = 0;
setTimeout(function () {
bowl.style.animation = 'none';
for (var i = 0; i < views.length; i++) {
views[i].loading = 'eager';
if (views[i].decode) views[i].decode().catch(function () {});
}
}, 1000);
bowl.addEventListener('touchstart', function (ev) {
grip = (!busy && ev.touches && ev.touches.length === 1) ? 1 : 0;
if (!grip) return;
bowl.style.willChange = 'translate';
sx = ev.touches[0].clientX;
sy = ev.touches[0].clientY;
st = Date.now();
}, { passive: true });
bowl.addEventListener('touchmove', function (ev) {
if (!grip || !ev.touches) return;
if (ev.touches.length > 1) { grip = 0; slide(0, 1, 200); return; }
var dx = ev.touches[0].clientX - sx, dy = ev.touches[0].clientY - sy;
if (grip === 1) {
if (Math.abs(dx) < 9 && Math.abs(dy) < 9) return;
grip = Math.abs(dx) > Math.abs(dy) ? 2 : 0;
if (!grip) return;
}
ev.preventDefault();
var x = 118 * Math.tanh(dx / 240);
slide(x, 1 - Math.abs(x) / 330, 0);
}, { passive: false });
bowl.addEventListener('touchcancel', function () {
if (grip === 2) slide(0, 1, 220);
grip = 0;
}, { passive: true });
bowl.addEventListener('touchend', function (ev) {
if (grip !== 2) { grip = 0; return; }
grip = 0;
bowl.style.willChange = '';
var t = ev.changedTouches && ev.changedTouches[0];
var dx = t ? t.clientX - sx : 0, dy = t ? t.clientY - sy : 0;
if (t && Date.now() - st <= 700 && Math.abs(dx) >= 40 && Math.abs(dx) >= Math.abs(dy) * 1.4) goView(dx < 0 ? 1 : -1);
else slide(0, 1, 240);
}, { passive: true });
}
for (var vb = 0; vb < viewBtns.length; vb++) {
(function (b) {
b.addEventListener('click', function () {
var g = b.getAttribute('data-go');
if (g === 'next') goView(1); else showView(g);
});
})(viewBtns[vb]);
}
var titleEl = root.querySelector('.wofp-title');
function fitTitle() {
if (!titleEl) return;
var lines = titleEl.getElementsByTagName('span');
for (var i = 0; i < lines.length; i++) {
var el = lines[i];
el.style.fontSize = '';
var avail = el.clientWidth;
if (!avail) continue;
var rg = document.createRange();
rg.selectNodeContents(el);
var tw = rg.getBoundingClientRect().width;
if (tw > avail - 1) el.style.fontSize = (parseFloat(getComputedStyle(el).fontSize) * ((avail - 1) / tw)).toFixed(2) + 'px';
}
}
safely(fitTitle, 'title fit');
if (document.fonts && document.fonts.ready && document.fonts.ready.then) document.fonts.ready.then(function () { safely(fitTitle, 'title refit'); });
var fitTimer = null;
window.addEventListener('resize', function () {
if (fitTimer) clearTimeout(fitTimer);
fitTimer = setTimeout(function () { safely(fitTitle, 'title refit'); }, 120);
});
var form = $('wofp-form');
var radios = root.querySelectorAll('.wofp-opt__in');
var qtyIn = $('wofp-qty');
function currentIndex() {
for (var i = 0; i < radios.length; i++) if (radios[i].checked) return i;
for (var j = 0; j < radios.length; j++) if (!radios[j].disabled) return j;
return 0;
}
function currentVariant() { return boot.variants[currentIndex()] || null; }
function qty() {
var n = parseInt(qtyIn.value, 10);
if (!(n >= 1)) n = 1;
if (n > 99) n = 99;
return n;
}
function renderDays() {
var opts = root.querySelectorAll('.wofp-opt');
var k = mer();
var nm = dogName();
var lastDays = 0, lastIdx = -1;
for (var i = 0; i < opts.length; i++) {
var slot = opts[i].querySelector('[data-days]');
var per = opts[i].querySelector('[data-perday]');
var v = boot.variants[i];
var d = (k > 0) ? packetKcal(packetGrams(v, i)) / k : 0;
if (slot) slot.textContent = dog.known ? (nm ? 'lasts ' + nm + ' ' + fmtSpan(d) : fmtSpan(d)) : '';
if (per) per.textContent = (dog.known && d > 0 && v && v.p > 0) ? money(v.p / d) + ' a day' : '';
lastDays = d; lastIdx = i;
}
/* The Large warning. Same five-day rule as the cart's suggestions (item 17):
   a Large only makes sense when the dog finishes it before thawed food turns.
   Shown to first-time customers only; a returning customer knows their freezer. */
var note = $('wofp-lgnote');
if (note) {
var keep = parseFloat(boot.keepDays) || 5;
var show = dog.known && !boot.returning && opts.length > 1 && lastIdx > 0 && lastDays > keep;
note.hidden = !show;
if (show) note.textContent = fill(boot.lgNote, { keep: keep === 5 ? 'five' : String(keep), lb: dog.weight_lb, days: fmtSpan(lastDays) });
}
}
function renderSum() {
var full = merFull(), c = full / boot.kcalCup, pct = porPct();
var s = 'A ' + dog.weight_lb + ' lb dog needs about ' + Math.round(full) +
' kcal a day, which is about ' + Math.round(c * 10) / 10 + ' cups. This recipe runs ' + Math.round(boot.kcalKg) +
' kcal per kg and ' + Math.round(boot.kcalCup) + ' kcal per cup.';
if (pct < 100) s += ' You are feeding Wynwood as ' + (PORNAME[pct] || 'part of their food') +
', so about ' + Math.round(mer()) + ' kcal of that comes from us.';
s += ' Have an intact dog, or want the whole breakdown? Use the <a href="' + boot.calc + '">feeding calculator</a>.';
$('wofp-how-body').innerHTML = s;
}
function daysPerPacket() {
var i = currentIndex(), v = currentVariant();
if (!v) return 0;
var k = mer();
if (!(k > 0)) return 0;
return packetKcal(packetGrams(v, i)) / k;
}
function packsForDays(d) {
var per = daysPerPacket();
if (!(per > 0)) return 0;
var n = Math.ceil(d / per);
return n > 99 ? 0 : Math.max(1, n);
}
function packsForBox() {
var i = currentIndex(), v = currentVariant();
var lb = parseFloat(boot.boxLb);
if (!v || !(lb > 0)) return 0;
var g = packetGrams(v, i);
if (!(g > 0)) return 0;
return Math.max(1, Math.min(99, Math.floor(lb * 453.59237 / g + 0.05)));
}
var PRE = [{ d: 7, t: '1 week' }, { d: 21, t: '3 weeks' }, { d: 30, t: '1 month' }];
function sizeWord(v) {
var t = String(v && v.t || '').split(' - ')[0].split(' / ')[0].trim();
return t || 'pack';
}
var preSet = false;
function preNode(chip) {
var el = chip.querySelector('[data-lbl]'), kids, i, nd;
if (el) return el;
kids = chip.childNodes;
for (i = 0; i < kids.length; i++) {
nd = kids[i];
if (nd.nodeType === 1 && !(nd.hasAttribute && nd.hasAttribute('data-free'))) return nd;
}
for (i = 0; i < kids.length; i++) {
nd = kids[i];
if (nd.nodeType === 3 && nd.nodeValue.replace(/\s/g, '')) return nd;
}
el = document.createElement('span');
el.setAttribute('data-lbl', '');
chip.insertBefore(el, chip.firstChild);
return el;
}
function preInit(chips) {
if (preSet) return;
preSet = true;
var i, nd;
for (i = 0; i < chips.length; i++) {
if (!PRE[i]) { chips[i].removeAttribute('data-days'); chips[i].removeAttribute('data-box'); continue; }
nd = preNode(chips[i]);
if (nd.nodeType === 3) nd.nodeValue = PRE[i].t; else nd.textContent = PRE[i].t;
if (chips[i].getAttribute('aria-label')) chips[i].setAttribute('aria-label', PRE[i].t);
chips[i].setAttribute('data-days', PRE[i].d);
chips[i].removeAttribute('data-box');
}
}
function renderPresets() {
var wrap = $('wofp-pre');
if (!wrap) return;
var chips = root.querySelectorAll('#wofp-pre-chips .wofp-pre__b');
var n = qty();
var v = currentVariant();
var fa = (parseFloat(boot.freeAt) || 0) * 100;
var shown = 0;
var want = [], i, j, chip;
preInit(chips);
for (i = 0; i < chips.length; i++) {
want[i] = PRE[i] ? packsForDays(PRE[i].d) : 0;
}
for (i = 0; i < want.length; i++) {
for (j = i + 1; j < want.length; j++) if (want[i] && want[i] === want[j]) want[i] = 0;
}
for (i = 0; i < chips.length; i++) {
chip = chips[i];
chip.classList.remove('is-first');
if (!want[i]) { chip.hidden = true; chip.setAttribute('data-n', ''); continue; }
chip.hidden = false;
if (!shown) chip.classList.add('is-first');
shown++;
chip.setAttribute('data-n', want[i]);
chip.setAttribute('aria-pressed', want[i] === n ? 'true' : 'false');
var tag = chip.querySelector('[data-free]');
if (tag) tag.hidden = !(fa > 0 && v && v.p * want[i] >= fa);
var sub = chip.querySelector('[data-sub]');
if (sub) sub.textContent = (dog.known && v) ? ((USUAL && USUAL.i === currentIndex() && USUAL.n === want[i]) ? 'Your usual \u00B7 ' : '') + want[i] + ' ' + sizeWord(v) + ' \u00B7 ' + money(v.p * want[i]) : '';
}
wrap.hidden = shown === 0;
wrap.style.opacity = dog.known ? '' : '.5';
}
function renderQty() {
var sum = $('wofp-add-sum');
var v = currentVariant();
var bk = $('wofp-bar-k'), bs = $('wofp-bar-sum');
if (!v) { sum.textContent = ''; if (bk) bk.textContent = ''; if (bs) bs.textContent = ''; return; }
sum.textContent = money(v.p * qty()) + ' total';
/* the sticky bar (wofp-page.js shows and hides it) repeats the same numbers */
if (bk) bk.textContent = qty() + ' ' + sizeWord(v);
if (bs) bs.textContent = money(v.p * qty());
}
var booted = false;
function renderAll() {
safely(renderDays, 'days');
safely(renderSum, 'summary');
safely(renderQty, 'quantity');
safely(renderPresets, 'presets');
if (booted) safely(renderShip, 'ship');
}
function chipSet(groupId, attr, value) {
var g = $(groupId);
if (!g) return;
var btns = g.querySelectorAll('.wofp-chip');
var matched = false;
for (var i = 0; i < btns.length; i++) {
var isOn = btns[i].getAttribute(attr) === String(value);
btns[i].setAttribute('aria-pressed', isOn ? 'true' : 'false');
if (isOn) matched = true;
}
if (!matched && btns.length) btns[0].setAttribute('aria-pressed', 'true');
}
function wireChips(groupId, attr, key) {
var g = $(groupId);
if (!g) return;
var btns = g.querySelectorAll('.wofp-chip');
for (var i = 0; i < btns.length; i++) {
(function (btn) {
btn.addEventListener('click', function () {
dog[key] = btn.getAttribute(attr);
chipSet(groupId, attr, dog[key]);
saveDog();
renderAll();
});
})(btns[i]);
}
}
wireChips('wofp-act-chips', 'data-act', 'activity');
var porBtns = root.querySelectorAll('#wofp-por .wofp-por__b');
if (porBtns.length) {
PORSET = {};
for (var pk = 0; pk < porBtns.length; pk++) {
var pkv = parseFloat(porBtns[pk].getAttribute('data-por'));
if (pkv > 0 && pkv <= 100) PORSET[pkv] = 1;
}
}
var porWrap = $('wofp-porw');
if (porWrap) porWrap.hidden = boot.porOn === false;
function porPaint() {
for (var i = 0; i < porBtns.length; i++) {
porBtns[i].setAttribute('aria-pressed', parseFloat(porBtns[i].getAttribute('data-por')) === porPct() ? 'true' : 'false');
}
}
for (var pb = 0; pb < porBtns.length; pb++) {
(function (btn) {
btn.addEventListener('click', function () {
var p = parseFloat(btn.getAttribute('data-por'));
if (!(p > 0 && p <= 100)) return;
dog.portion = p;
porPaint();
saveDog();
pFd();
renderAll();
});
})(porBtns[pb]);
}
function agePaint() {
var pup = parseFloat(dog.age) > 1;
var sub = $('wofp-pup-chips');
if (sub) sub.hidden = !pup;
var a = root.querySelectorAll('#wofp-age-chips .wofp-chip');
for (var i = 0; i < a.length; i++) {
var on = a[i].getAttribute('data-pup') ? pup : (!pup && a[i].getAttribute('data-age') === dog.age);
a[i].setAttribute('aria-pressed', on ? 'true' : 'false');
}
if (pup) chipSet('wofp-pup-chips', 'data-age', dog.age);
}
function ageSet(v) {
dog.age = String(v);
agePaint();
saveDog();
renderAll();
}
function pupPick() {
var b = root.querySelectorAll('#wofp-pup-chips .wofp-chip');
for (var i = 0; i < b.length; i++) if (b[i].getAttribute('aria-pressed') === 'true') return b[i].getAttribute('data-age');
return '1.5';
}
var ageBtns = root.querySelectorAll('#wofp-age-chips .wofp-chip,#wofp-pup-chips .wofp-chip');
for (var ab = 0; ab < ageBtns.length; ab++) {
(function (btn) {
btn.addEventListener('click', function () {
ageSet(btn.getAttribute('data-pup') ? pupPick() : btn.getAttribute('data-age'));
});
})(ageBtns[ab]);
}
function hasBday() {
try { return !!(window.wynProfile && window.wynProfile.get().bday); } catch (e) { return false; }
}
function ageRowSync() {
var chips = $('wofp-age-chips');
if (!chips) return;
var bd = hasBday();
var row = chips.closest('.wofp-q');
if (row) row.style.display = bd ? 'none' : '';
var fold = chips.closest('details');
var sum = fold ? fold.querySelector(':scope > summary') : null;
if (sum) {
if (sum.getAttribute('data-wofp-label') == null) sum.setAttribute('data-wofp-label', sum.textContent);
sum.textContent = bd ? BD_FOLD_LABEL : sum.getAttribute('data-wofp-label');
}
/* the birthday's age wins over anything another surface last broadcast */
if (bd) {
var ba = window.wynProfile.get().age;
if (ba && String(ba) !== dog.age) dog.age = String(ba);
}
}
safely(ageRowSync, 'age row');
var wtEl = $('wofp-dog-wt');
var slideEl = $('wofp-dog-slide');
var wtField = root.querySelector('.wofp-wt__blank');
if (wtField && wtEl) {
wtField.addEventListener('click', function (ev) {
if (ev.target !== wtEl) { wtEl.focus(); wtEl.select(); }
});
}
if (wtEl) wtEl.addEventListener('focus', function () { wtEl.select(); });
function wtSet(n, from) {
n = Math.round(n);
if (!(n >= 1)) n = 1;
if (n > 250) n = 250;
dog.weight_lb = n;
if (wtEl && from !== 'input') wtEl.value = n;
if (slideEl && from !== 'slide') slideEl.value = wtToPos(n);
if (slideEl) slideEl.setAttribute('aria-valuetext', n + ' lb');
saveDog();
pFd();
renderAll();
}
if (slideEl) slideEl.addEventListener('input', function () { wtSet(posToWt(parseFloat(slideEl.value)), 'slide'); });
if (slideEl) slideEl.addEventListener('keydown', function (ev) {
var d = 0, k = ev.key;
if (k === 'ArrowLeft' || k === 'ArrowDown') d = -wtStep(dog.weight_lb);
else if (k === 'ArrowRight' || k === 'ArrowUp') d = wtStep(dog.weight_lb);
else if (k === 'PageDown') d = -10;
else if (k === 'PageUp') d = 10;
if (!d) return;
ev.preventDefault();
wtSet(dog.weight_lb + d);
});
if (wtEl) wtEl.addEventListener('input', function () {
var n = parseFloat(wtEl.value);
if (!isNaN(n) && n >= 1) wtSet(n, 'input');
});
if (wtEl) wtEl.addEventListener('blur', function () { wtEl.value = dog.weight_lb; });
var wtBtns = root.querySelectorAll('.wofp-wt__step');
for (var w = 0; w < wtBtns.length; w++) {
(function (btn) {
btn.addEventListener('click', function () {
wtSet(dog.weight_lb + (parseInt(btn.getAttribute('data-wt'), 10) || 0));
});
})(wtBtns[w]);
}
if (wtEl) wtEl.value = dog.weight_lb;
if (slideEl) slideEl.value = wtToPos(dog.weight_lb);
if (slideEl) slideEl.setAttribute('aria-valuetext', dog.weight_lb + ' lb');
agePaint();
porPaint();
chipSet('wofp-act-chips', 'data-act', dog.activity);
function syncControls() {
if (wtEl) wtEl.value = dog.weight_lb;
if (slideEl) {
slideEl.value = wtToPos(dog.weight_lb);
slideEl.setAttribute('aria-valuetext', dog.weight_lb + ' lb');
}
agePaint();
porPaint();
chipSet('wofp-act-chips', 'data-act', dog.activity);
pFd();
}
/* THE STRIP. A new visitor sees it open, weight and chips ready, because every
   number below it depends on the answer. Someone whose dog we already know sees
   one line with an Edit tab. Once a person has opened or closed it themselves
   (wheld), the page never changes it under them again. */
var wdd = $('wofp-dogd'), wdt = $('wofp-dogt'), wheld = false, wauto = false;
function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
function pFd(n) {
if (!wdd) return;
if (!wheld && !wauto) {
wauto = true;
wdd.open = !dog.known;
var meta = wdd.querySelector('.wofp-meta details');
if (meta && !dog.known) meta.open = true;
}
wdd.classList.toggle('is-q', !dog.known);
var wv = '<b>' + dog.weight_lb + ' lb</b>';
var ps = PORSUM[porPct()] ? ', ' + PORSUM[porPct()] : '';
var nm = dogName();
var line;
if (n) line = 'That count assumes a ' + wv + ' dog' + ps + '.';
else if (!dog.known) line = esc(boot.stripAsk || 'How much does your dog weigh?');
else if (nm) line = fill(esc(boot.stripFor || 'For {name}, {lb} lb{share}.'), { name: '<b>' + esc(nm) + '</b>', lb: '<b>' + dog.weight_lb + '</b>', share: ps });
else line = fill(esc(boot.stripYou || 'For your {lb} lb dog{share}.'), { lb: '<b>' + dog.weight_lb + '</b>', share: ps });
if (USUAL && boot.usualDate && !n && dog.known) {
var uv = boot.variants[USUAL.i];
line += ' <span class="wofp-dogd__last">' + esc(fill(boot.usualLine || 'Last order {date}: {qty} {size}.', { date: boot.usualDate, qty: USUAL.n, size: uv ? sizeWord(uv) : 'pack' })) + '</span>';
}
if (wdt) wdt.innerHTML = line;
}
if (wdd) wdd.querySelector('summary').addEventListener('click', function () { wheld = true; });
var doneBtn = $('wofp-dog-done');
if (doneBtn && wdd) doneBtn.addEventListener('click', function () {
wheld = true;
dog.known = true;
saveDog();
wdd.open = false;
pFd();
renderAll();
try { wdd.scrollIntoView({ block: 'nearest' }); } catch (e) {}
});
function bFd() {
if (!wdd || wdd.open || dog.known) return;
pFd(1);
wdd.classList.remove('is-beat');
void wdd.offsetWidth;
wdd.classList.add('is-beat');
}
document.addEventListener('wyn:dog', function (e) {
var d = e && e.detail;
if (!d || typeof d.weight_lb !== 'number') return;
var dp = (d.portion > 0 && d.portion <= 100) ? Math.round(d.portion) : dog.portion;
if (d.weight_lb === dog.weight_lb && String(d.age) === dog.age && String(d.activity) === dog.activity && dp === dog.portion) return;
dog.weight_lb = Math.round(d.weight_lb);
if (d.age) dog.age = String(d.age);
if (d.activity) dog.activity = String(d.activity);
dog.portion = dp;
dog.known = true;
stamp = Date.now();
safely(ageRowSync, 'age row');
syncControls();
renderAll();
});
function repull() {
var fresh = readDog();
if (!fresh.known) return;
if (stamp && !(fresh.updated > stamp)) return;
if (fresh.weight_lb === dog.weight_lb && fresh.age === dog.age && fresh.activity === dog.activity && fresh.portion === dog.portion) return;
dog = fresh;
safely(ageRowSync, 'age row');
syncControls();
renderAll();
}
document.addEventListener('visibilitychange', function () {
if (document.hidden) return;
repull();
if (booted) safely(renderShip, 'ship wake');
});
window.addEventListener('pageshow', repull);
function sizeChanged() {
renderQty();
renderPresets();
safely(renderShip, 'ship size');
var v = currentVariant();
if (!v) return;
var oz = Math.round(packetGrams(v, currentIndex()) / OZ);
if (!(oz > 0)) return;
try { document.dispatchEvent(new CustomEvent('wyn:size', { detail: { oz: oz }, bubbles: true })); } catch (e) {}
}
for (var r = 0; r < radios.length; r++) {
radios[r].addEventListener('change', sizeChanged);
}
var qtyBtns = root.querySelectorAll('.wofp-qty__btn');
for (var q = 0; q < qtyBtns.length; q++) {
(function (btn) {
btn.addEventListener('click', function () {
var n = qty() + (parseInt(btn.getAttribute('data-step'), 10) || 0);
if (n < 1) n = 1;
if (n > 99) n = 99;
qtyIn.value = n;
qtyChanged();
});
})(qtyBtns[q]);
}
function qtyChanged() { renderQty(); renderPresets(); safely(renderShip, 'ship'); }
qtyIn.addEventListener('input', qtyChanged);
var qtyCell = root.querySelector('.wofp-qty__cell');
if (qtyCell && qtyIn) {
qtyCell.addEventListener('click', function (ev) {
if (ev.target !== qtyIn) { qtyIn.focus(); qtyIn.select(); }
});
qtyIn.addEventListener('focus', function () { qtyIn.select(); });
}
var preChips = root.querySelectorAll('#wofp-pre-chips .wofp-pre__b');
for (var pc = 0; pc < preChips.length; pc++) {
(function (chip) {
chip.addEventListener('click', function () {
var want = parseInt(chip.getAttribute('data-n'), 10);
if (!(want >= 1)) return;
qtyIn.value = want;
qtyChanged();
bFd();
});
})(preChips[pc]);
}
function etNow() {
try {
var d = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
return isNaN(d.getTime()) ? new Date() : d;
} catch (e) { return new Date(); }
}
function parseDays(str) {
var out = [];
var parts = String(str || '').split(',');
for (var i = 0; i < parts.length; i++) {
var n = parseInt(parts[i], 10);
if (n >= 0 && n <= 6) out.push(n);
}
return out;
}
var DAYNAME = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
function dayList(ds) {
var n = ds.length;
if (!n) return '';
if (n === 1) return DAYNAME[ds[0]] + 's';
var contig = true;
for (var i = 1; i < n; i++) if (ds[i] !== ds[i - 1] + 1) { contig = false; break; }
if (contig && n > 2) return DAYNAME[ds[0]] + 's through ' + DAYNAME[ds[n - 1]] + 's';
var parts = [];
for (var j = 0; j < n; j++) parts.push(DAYNAME[ds[j]] + 's');
return parts.slice(0, -1).join(', ') + ' and ' + parts[n - 1];
}
var FLKEY = 'wyn_fl';
var znEl = null;
var znFL = false;
function flOn() { return znFL; }
function paintZn() {
if (!znEl) return;
znEl.textContent = znFL ? 'FL' : 'USA';
znEl.setAttribute('aria-pressed', znFL ? 'true' : 'false');
}
var DAYSHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
var MONSHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
function fmtDate(d) { return DAYSHORT[d.getDay()] + ' ' + MONSHORT[d.getMonth()] + ' ' + d.getDate(); }
function fmtSum(a, b) {
var m1 = MONSHORT[a.getMonth()], d1 = a.getDate(), d2 = b.getDate();
if (a.getMonth() === b.getMonth()) return m1 + '\u00A0' + d1 + (d1 === d2 ? '' : '\u2013' + d2);
return m1 + '\u00A0' + d1 + ' \u2013 ' + MONSHORT[b.getMonth()] + '\u00A0' + d2;
}
/* Closed days. blackout: nothing ships out of state. blackoutFl: nothing
ships in-state (Florida). A page without blackoutFl uses one list for both. */
function closedMap(str) {
var m = {}, rows = String(str || '').split(',');
for (var i = 0; i < rows.length; i++) {
var p = String(rows[i]).split('|'), k = (p[0] || '').replace(/\s/g, '');
if (k) m[k] = (p[1] || '').trim() || 'a holiday';
}
return m;
}
var BLACK_US = closedMap(boot.blackout);
var BLACK_FL = boot.blackoutFl === undefined ? BLACK_US : closedMap(boot.blackoutFl);
function isoOf(d) { function p(n) { return (n < 10 ? '0' : '') + n; }
return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()); }
function blacked(d) { return (flOn() ? BLACK_FL : BLACK_US)[isoOf(d)] || null; }
var lastSkip = null;
/* Days no carrier delivers: New Year's Day, Memorial Day, the Fourth of July,
   Labor Day, Thanksgiving and Christmas (moved to Monday when it falls on a
   Sunday). The same rule as the order tracker. */
var NODEL = {};
function nthDow(y, m, wd, n) {
if (n > 0) { var f = new Date(y, m, 1); return new Date(y, m, 1 + ((wd - f.getDay() + 7) % 7) + (n - 1) * 7); }
var l = new Date(y, m + 1, 0); return new Date(y, m, l.getDate() - ((l.getDay() - wd + 7) % 7));
}
function carrierOff(d) {
var y = d.getFullYear();
if (!NODEL[y]) {
var set = {};
[new Date(y, 0, 1), nthDow(y, 4, 1, -1), new Date(y, 6, 4), nthDow(y, 8, 1, 1), nthDow(y, 10, 4, 4), new Date(y, 11, 25)].forEach(function (h) {
set[isoOf(h)] = 1;
if (h.getDay() === 0) set[isoOf(new Date(y, h.getMonth(), h.getDate() + 1))] = 1;
});
NODEL[y] = set;
}
return NODEL[y][isoOf(d)] === 1;
}
/* n delivery days after the ship day, skipping Sundays and carrier holidays. */
function arriveAfter(ship, n) {
var d = new Date(ship.getFullYear(), ship.getMonth(), ship.getDate(), 12), moved = 0, guard = 0;
while (moved < n && guard++ < 60) {
d = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1, 12);
if (d.getDay() === 0 || carrierOff(d)) continue;
moved++;
}
return d;
}
function nextShipDay(from, days, missedToday) {
var probe = new Date(from.getTime());
if (missedToday) probe = new Date(probe.getTime() + DAY);
lastSkip = null;
for (var i = 0; i < 30; i++) {
if (days.indexOf(probe.getDay()) !== -1) {
var h = blacked(probe);
if (!h) return probe;
if (!lastSkip) lastSkip = h;
}
probe = new Date(probe.getTime() + DAY);
}
return probe;
}
function cutTxt(c) { return c === 12 ? 'noon' : (c > 12 ? (c - 12) + 'pm' : c + 'am'); }
function renderShip() {
var wrap = $('wofp-ship');
if (!wrap) return;
var now = etNow();
var fl = flOn();
var days = parseDays(fl ? boot.flDays : boot.usDays);
var transit = parseDays(fl ? boot.flTransit : boot.usTransit);
if (!days.length) { wrap.hidden = true; return; }
var cutoff = boot.cutoff;
var hrs = now.getHours() + now.getMinutes() / 60;
var pastCutoff = hrs >= cutoff;
var isShipDay = days.indexOf(now.getDay()) !== -1 && !blacked(now);
var ship = nextShipDay(now, days, pastCutoff && isShipDay);
var skipHol = lastSkip;
var lo = transit.length ? transit[0] : 2;
var hi = transit.length > 1 ? transit[transit.length - 1] : lo + 1;
var arriveLo = arriveAfter(ship, lo);
var arriveHi = arriveAfter(ship, hi);
var cdEl = $('wofp-sh-cd');
if (ship.toDateString() === now.toDateString() && !pastCutoff) {
var mins = Math.max(0, Math.round((cutoff - hrs) * 60));
var h = Math.floor(mins / 60), m = mins % 60;
var cd = (h > 0 ? h + 'h' + (m > 0 ? ' ' + m + 'm' : '') : m + 'm') + ' left today';
$('wofp-ship-order').textContent = cd;
wrap.querySelector('[data-s="order"]').classList.add('is-live');
if (cdEl) { cdEl.textContent = cd; cdEl.hidden = false; }
} else {
$('wofp-ship-order').textContent = 'Today';
wrap.querySelector('[data-s="order"]').classList.remove('is-live');
if (cdEl) { cdEl.textContent = ''; cdEl.hidden = true; }
}
$('wofp-ship-ship').textContent = fmtDate(ship);
$('wofp-ship-get').textContent = arriveLo.getDate() === arriveHi.getDate()
? fmtDate(arriveLo)
: fmtDate(arriveLo) + ' to ' + fmtDate(arriveHi);
var sumEl = $('wofp-sh-sum');
if (sumEl) sumEl.textContent = fmtSum(arriveLo, arriveHi);
var noteEl = $('wofp-ship-note');
if (noteEl) {
var gw = parseFloat(boot.gapWarn) || 0;
var slip = null;
if (gw > 0 && isShipDay && !pastCutoff) {
var later = nextShipDay(now, days, true);
if (Math.round((later.getTime() - ship.getTime()) / DAY) >= gw) slip = later;
}
noteEl.hidden = !slip;
if (slip) noteEl.textContent = 'After today\'s ' + cutTxt(cutoff) + ' cutoff, the next box leaves ' + fmtDate(slip) + '.';
}
var moneyEl = $('wofp-ship-money');
if (moneyEl) {
var bar = document.querySelector('free-shipping-bar');
var raw = bar ? String(bar.getAttribute('data-frozen-subtotal') || '') : '';
var fc = parseFloat(raw) || 0;
if (raw.indexOf('.') === -1) fc = fc / 100;
var mn = parseFloat(boot.minAt) || 0, fa = parseFloat(boot.freeAt) || 0, ff = parseFloat(boot.shipFlat) || 0;
var msg = '', low = mn > 0 && fc > 0 && fc < mn;
moneyEl.classList.toggle('is-min', low);
if (low) {
msg = 'Add ' + money((mn - fc) * 100) + ' more in frozen food to check out. Under $' + mn + ' a box cannot stay cold.';
} else if (fc <= 0) {
msg = mn > 0 ? 'Frozen orders start at $' + mn + '.' : '';
} else if (fa > 0 && ff > 0 && fc < fa) {
msg = 'This cart ships for $' + ff + '. Add ' + money((fa - fc) * 100) + ' for free.';
}
moneyEl.hidden = !msg;
moneyEl.textContent = msg;
}
var fine = 'Leaves Miami ' + dayList(days) +
', cutoff ' + cutTxt(cutoff) + ' Eastern.';
var bx = packsForBox(), nq = qty();
if (skipHol) fine += ' Closed for ' + skipHol + '.';
if (!fl && boot.flNote) fine += ' ' + boot.flNote;
if (bx > 0 && nq > bx) fine += ' Ships in ' + Math.ceil(nq / bx) + ' boxes.';
$('wofp-ship-fine').textContent = fine;
wrap.hidden = false;
}
function showErr(msg) {
var el = $('wofp-err');
el.textContent = msg;
el.hidden = false;
}
form.addEventListener('submit', function (ev) {
if (!window.fetch) return;
ev.preventDefault();
var el = $('wofp-err');
el.hidden = true;
el.textContent = '';
var btn = $('wofp-add');
var bar = $('wofp-bar-add');
var v = currentVariant();
if (!v || !v.a) { showErr('That size is sold out right now.'); return; }
btn.classList.add('is-busy');
if (bar) bar.classList.add('is-busy');
fetch('/cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ id: v.id, quantity: qty() })
})
.then(function (res) {
if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart.'); });
return res.json();
})
.then(function () {
btn.classList.remove('is-busy');
if (bar) bar.classList.remove('is-busy');
openCart();
})
.catch(function (err) {
btn.classList.remove('is-busy');
if (bar) bar.classList.remove('is-busy');
showErr(err && err.message ? err.message : 'Could not add to cart. Try again.');
});
});
function openCart() {
if (boot.afterAdd === 'page') { window.location.href = '/cart'; return; }
var elId = boot.cartEl || 'mini-cart';
var secId = boot.cartSec || elId;
var live = document.getElementById(elId);
var trigger = document.querySelector('[aria-controls="' + elId + '"]');
var swapped = false;
function hasLines() {
return !!(live && live.querySelector('[name^="updates"],a[href*="/cart/change"],[data-line-item],[data-cart-item],.line-item,.cart-item'));
}
function watch() {
if (!boot.cartBail) return;
/* The Added sheet (theme.liquid, item 29) now confirms the add and keeps the
   drawer shut on purpose, so an empty drawer is not a sign that anything
   failed. Sending the customer to /cart from here would be a bug. */
if (window.wofpzAddBar) return;
setTimeout(function () {
if (swapped || hasLines()) return;
fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
.then(function (r) { return r.json(); })
.then(function (c) {
if (!c || !(c.item_count > 0)) return;
if (window.console) console.warn('wofp cart: cart has ' + c.item_count + ' item(s), drawer empty. Going to /cart.');
window.location.href = '/cart';
})
.catch(function () {});
}, 900);
}
/* Events then reveal, so the theme repaints off screen. Do not reorder. */
document.dispatchEvent(new CustomEvent('variant:added', { bubbles: true }));
document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
if (!trigger) { window.location.href = '/cart'; return; }
trigger.click();
watch();
if (!live || !window.DOMParser) return;
function swap(html) {
if (!html) return false;
try {
var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(elId);
if (!fresh || !fresh.innerHTML) return false;
live.innerHTML = fresh.innerHTML;
swapped = true;
return true;
} catch (e) { if (window.console) console.warn('wofp cart: could not parse the refreshed drawer.', e); return false; }
}
function grab(url) {
return fetch(url, { credentials: 'same-origin' })
.then(function (r) { return r.ok ? r.text() : ''; })
.then(swap)
.catch(function () { return false; });
}
setTimeout(function () {
grab('/cart?section_id=' + encodeURIComponent(secId))
.then(function (ok) { return ok ? true : grab('/cart'); })
.then(function (ok) {
if (!ok && window.console) console.warn('wofp cart: drawer empty, no fresh markup. Check wofp_cart_el/sec.');
});
}, boot.cartWait || 350);
}
znEl = $('wofp-zn');
if (znEl) {
try { znFL = localStorage.getItem(FLKEY) === '1'; } catch (e) {}
paintZn();
znEl.addEventListener('click', function (ev) {
ev.preventDefault();
ev.stopPropagation();
znFL = !znFL;
try { localStorage.setItem(FLKEY, znFL ? '1' : '0'); } catch (e) {}
paintZn();
safely(renderShip, 'ship fl');
});
}
safely(function () {
var b0 = boot.variants[0];
if (!b0) return;
var per0 = b0.p / packetGrams(b0, 0);
var tg = root.querySelectorAll('[data-save]');
for (var i = 0; i < tg.length; i++) {
var v = boot.variants[i + 1];
if (!v || !(v.p > 0)) continue;
var pct = Math.round((1 - (v.p / packetGrams(v, i + 1)) / per0) * 100);
if (pct >= 1) tg[i].textContent = 'Save ' + pct + '%';
}
}, 'savings');
/* YOUR USUAL (returning customers): the size and count from the last order
   that held this diet are preselected, so Add to cart is one press. */
var USUAL = null;
safely(function () {
if (!boot.returning || !(boot.usualVid > 0) || !(boot.usualQty > 0)) return;
for (var i = 0; i < radios.length; i++) {
if (String(radios[i].value) === String(boot.usualVid) && !radios[i].disabled) {
radios[i].checked = true;
qtyIn.value = Math.min(99, Math.max(1, Math.round(boot.usualQty)));
USUAL = { i: i, n: qty() };
break;
}
}
}, 'usual');
booted = true;
pFd();
renderAll();
var cdr = document.getElementById(boot.cartEl || 'mini-cart');
if (cdr && window.MutationObserver) new MutationObserver(function () { safely(renderShip, 'cart'); }).observe(cdr, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-frozen-subtotal'] });
var shipTimer = setInterval(function () { safely(renderShip, 'ship tick'); }, 60000);
window.addEventListener('pagehide', function () { if (shipTimer) { clearInterval(shipTimer); shipTimer = null; } });
})();